import styled from '@emotion/styled';

export const StyledTabs = styled.div`
  overflow: hidden;
`;

export const StyledTabList = styled.div`
  align-items: flex-start;
  display: flex;
  overflow: auto;
`;
